export default function (router) {
    router.beforeEach((to, from, next) => {
        if (! to.meta.middleware || ! to.meta.middleware.mustBeAuthenticated) return next();

        const store = router.app.$store;

        if (router.app.$store.state.auth.authenticated) return next();

        store.dispatch('auth/logout', '/login');
    })
}